export function getDateDiffInDays(a) {
	// a and b are javascript Date objects
	const _MS_PER_DAY = 1000 * 60 * 60 * 24;
	  // Discard the time and time-zone information.
	const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
	const utc2 = new Date();

	return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}
